  <template>
  <keep-alive>
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="less">
/*每个页面公共css */
@import url("./common/iconfont.css");
@import url("./common/base.css");
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  padding: 0;
  margin: 0px;
}
.y1200 {
  width: 1200px;
  margin: 0 auto;
}
.y900 {
  width: 900px;
  margin: 0 auto;
}
.bannerx {
  background: url(assets/images/about_banner.jpg) no-repeat;
  width: 100%;
  height: 400px;
  background-position: top;
}
.bannery {
  background: url(assets/images/kj_banner.jpg) no-repeat;
  width: 100%;
  height: 400px;
  background-position: top;
}
.bannerd {
  background: url(assets/images/de_banner.jpg) #fff no-repeat;
  width: 100%;
  background-position: top;
  background-color: #fff;
}
.bannerr {
  background: url(assets/images/rz_banner.jpg) #fff no-repeat;
  width: 100%;
  background-position: top;
  background-color: #fff;
}
</style>
